module.exports = __webpack_public_path__ + "img/T7A6671.fc6e7305.jpg";